import { useEffect } from 'react';

import { useAuthService, useDataClientService, useUserState } from '@stores/AppStateContext';
import { syncBrowserPushSubscription } from '../../../actions/notification/pushSubscriptions';

export const PushNotificationsSync = () => {
    const authService = useAuthService();
    const dataClientService = useDataClientService();
    const userState = useUserState();

    useEffect(() => {
        if (!userState?.currentUserId) {
            return;
        }

        void syncBrowserPushSubscription(
            {
                authService,
                dataClientService,
            },
            {
                promptIfNeeded: true,
                promptStorageKey: `push-notification-permission-requested:${userState.tenantId}:${userState.currentUserId}`,
            }
        );
    }, [
        authService,
        dataClientService,
        userState?.currentUserId,
        userState?.tenantId,
    ]);

    return null;
};
